import { render, staticRenderFns } from "./FrequentlyAsked.vue?vue&type=template&id=1053fc2e&scoped=true&"
import script from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAsked.vue?vue&type=style&index=0&id=1053fc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053fc2e",
  null
  
)

export default component.exports